import { DateTime } from "luxon";
// FIXME: We are not importing via `~utils` due to a circular dependency
import { translate } from "utils/string-table";

/***** Constants *****/
// Delay options in hours (0.25 = 15 minutes)
export const DELAY_OPTIONS_IN_HOURS = [1 / 6, 1, 4, 12, 24];

export const ONLY_SELECTED_SUBS_CHOICE = translate("TIME_TO_ACCEPT_ONLY_SELECTED_SUBS_VALUE");

/***** Types *****/
export type TimeToAcceptParams = {
  startDateTime: DateTime;
  now: DateTime;
};

/***** Helpers *****/
/**
 * Returns available delay options based on how far away the request
 * start time is.
 *
 * Shows only options that fit within the available timeframe, plus
 * "Only Selected Subs" option.
 */
export function getTimeToAcceptChoices(params: TimeToAcceptParams) {
  const { startDateTime, now = DateTime.now() } = params;

  const hoursUntilRequest = startDateTime.diff(now, "hours").hours;

  // Filter to only show options that fit within the available time
  const availableOptions = DELAY_OPTIONS_IN_HOURS.filter(
    (delayInHours) => hoursUntilRequest >= delayInHours,
  );

  // Always include "Only Selected Subs" as the last option
  return [...availableOptions, ONLY_SELECTED_SUBS_CHOICE];
}
